import { z } from 'zod';
/** Milliseconds since the Unix epoch (UTC). */
export const TimestampMs = z.number().int().nonnegative();
export const Id = z.string().min(1);
export const Agent = z.enum(['claude', 'codex']);
/** Arbitrary JSON value carried verbatim (tool inputs, structured outputs, raw passthrough). */
export const Json = z.unknown();
/** An image either inlined (base64) or referenced (URL / artifact / local path on the run's machine). */
export const ImageRef = z.object({
    mime: z.string(),
    dataBase64: z.string().optional(),
    url: z.string().optional(),
    artifactId: z.string().optional(),
    path: z.string().optional(),
    width: z.number().int().positive().optional(),
    height: z.number().int().positive().optional(),
    alt: z.string().optional(),
});
export const DiffHunk = z.object({
    oldStart: z.number().int(),
    oldLines: z.number().int(),
    newStart: z.number().int(),
    newLines: z.number().int(),
    /** Lines prefixed with ' ', '+', '-' (or '\\' for "no newline"). */
    lines: z.array(z.string()),
});
export const FileDiff = z.object({
    path: z.string(),
    op: z.enum(['add', 'modify', 'delete', 'rename']),
    /** Destination path for renames/moves. */
    movePath: z.string().optional(),
    /** Unified diff text for this file (may be the full content for `add`). */
    unified: z.string().optional(),
    hunks: z.array(DiffHunk).optional(),
    additions: z.number().int().nonnegative().optional(),
    deletions: z.number().int().nonnegative().optional(),
    binary: z.boolean().optional(),
});
/** Rich content part used for tool results and user messages. */
export const ContentPart = z.discriminatedUnion('type', [
    z.object({ type: z.literal('text'), text: z.string() }),
    z.object({ type: z.literal('image'), image: ImageRef }),
    z.object({
        type: z.literal('file'),
        path: z.string(),
        mime: z.string().optional(),
        name: z.string().optional(),
    }),
    z.object({ type: z.literal('json'), value: Json }),
]);
//# sourceMappingURL=common.js.map